import PersonalSetDetail from "@/pages/PersonalSetDetail";
export default function SetDetail() { return <PersonalSetDetail fixedKind="official" browse />; }
